<template>
    <div class="p-3 relative mb-2 border-b border-gray-1" data-cy="container_serial_detail">
        <div class="flex items-center">
            <div class="flex-none w-13 h-13 campaign-image rounded-md overflow-hidden" data-cy="container_serial_detail_campaign_image">
                <div :style="{ 'background-image': `url('${serialModel.campaignImgUrl}')` }" data-cy="img_serial_detail_campaign_image"></div>
                <!-- <div class="mockup-img"></div> -->
            </div>

            <div class="flex-auto">
                <div
                    class="text-xs text-dark-7 font-bold pl-3 leading-relaxed font-main-bold"
                    data-cy="text_serial_detail_campaign_name"
                >{{ serialModel.campaignName }}</div>
                <div class="text-xs text-dark-6 pl-3" data-cy="text_serial_detail_privilege_message">{{ serialModel.privilegeMessage }}</div>
            </div>
        </div>
        <div class="absolute -right-3 -top-4">
            <button class="ountline-none appearance-none" @click="clickClose()" data-cy="btn_serial_detail_close">
                <img src="@/assets/icons/button/btn-close.svg" />
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "SerialDetail",
    props: {
        serialModel: Object,
    },
    inject: ["eventBus"],
    methods: {
        clickClose: function () {
            this.eventBus.emit("clickClose")
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/image.scss";
.campaign-image {
    div {
        @include boxRatio(100%);

        background-image: url("~@/assets/imgs/mockup/hungry-nerd-thumbnail.png");
    }
}
</style>
